import "./dialogCountDown.scss";
import Vue from "vue";

const casinoIcon = require("@/assets/icons-file/casino/pic_casino_popup_waiting@3x.png");

export default function dialogCountDownTime(timeStamp: number) {
  const El = Vue.extend({
    template: `
        <div class="count-down-wrappe">
            <img :src="casinoIcon" class="casino-icon">
            <div class="count-down">
              <span>FREE IN </span>
              <p>{{countDownTime}}</p>
            </div>
        </div>`,
    mounted() {
      const nowTimeStamp = new Date().getTime();
      this.countDownTimeData = (this.timeStamp - nowTimeStamp) / 1000;
      const timer = setInterval(() => {
        if (Math.floor(this.countDownTimeData) > 1) {
          this.countDownTimeData--;
        } else {
          clearInterval(timer);
        }
      }, 1000);
    },
    data() {
      return {
        countDownTimeData: 0
      };
    },
    computed: {
      timeStamp() {
        return timeStamp;
      },
      casinoIcon() {
        return casinoIcon;
      },
      countDownTime() {
        const time: any = this.countDownTimeData;
        const h =
          Math.floor(time / 3600) < 10
            ? "0" + Math.floor(time / 3600)
            : Math.floor(time / 3600);
        const m =
          Math.floor((time / 60) % 60) < 10
            ? "0" + Math.floor((time / 60) % 60)
            : Math.floor((time / 60) % 60);
        const s =
          Math.floor(time % 60) < 10
            ? "0" + Math.floor(time % 60)
            : Math.floor(time % 60);
        return `${h}:${m}:${s}`;
      }
    }
  });
  return new El();
}
